// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__22VoE","title":"FrontImage_title__1dvDH"};